import Vue from 'vue'
import Vuetify from 'vuetify/lib'

Vue.use(Vuetify)

// export default new Vuetify({
// })

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#6ec39b',
        secondary: '#c9242b',
        accent: '#8c9eff',
        error: '#b71c1c',
      },
    },
  },
})
